"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RemoveSavedIdModalState = /** @class */ (function () {
    function RemoveSavedIdModalState() {
        this.showModal = false;
        this.disableContinue = true;
    }
    return RemoveSavedIdModalState;
}());
exports.default = RemoveSavedIdModalState;
//# sourceMappingURL=RemoveSavedIdModalState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/RemoveSavedIDModal/RemoveSavedIdModalState.js
// module id = 1508
// module chunks = 8